module.exports = __webpack_public_path__ + "img/partner_17.f1db7b49.png";